const defaultMask = '__/__/____';
const defaultFormat = 'MM/dd/yyyy';

export { defaultFormat, defaultMask };
